import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanDeactivate,
    RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { CoachingSwitchboardService } from './switchboard';

@Injectable()
export class CoachingCanDeactivateService implements CanDeactivate<any> {
    constructor(
        private readonly _switchboardService: CoachingSwitchboardService,
    ) {}

    canDeactivate(
        component: any,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot,
    ): Observable<boolean> | Promise<boolean> | boolean {
        // when a commitment is present it must have final say
        if (
            this._switchboardService.observationReview.connected() &&
            !this._switchboardService.commitment.connected()
        ) {
            const ret = this._switchboardService.observation.sbCanCancelEdit(
                currentState,
                nextState,
            );
            if (ret instanceof Observable) {
                return ret.pipe(
                    tap((canDeactivate) => {
                        if (canDeactivate) {
                            this._switchboardService.observationReview.sbWillNavigate();
                        }
                    }),
                );
            } else {
                if (ret) {
                    this._switchboardService.observationReview.sbWillNavigate();
                }
                return ret;
            }
        }
        return true;
    }
}
